module.exports = __webpack_public_path__ + "img/motorway_7x2.5972a604.svg";